// extracted by mini-css-extract-plugin
export default {"confirm":"DeleteButton_confirm__bCd-q","btnContainer":"DeleteButton_btnContainer__R-IGc"};